<div class="cs-page">

  <!-- Header sticky -->
  <div class="cs-header">
    <div class="cs-header__icon">
      <mat-icon>insert_chart</mat-icon>
    </div>
    <div class="cs-header__text">
      <h1 class="cs-header__title">Estadísticas de conceptos</h1>
      <p class="cs-header__sub">Analiza rentabilidad y volumen de ventas por concepto</p>
    </div>
    <div class="cs-header__filter">
      <mat-form-field appearance="outline" class="cs-months-field">
        <mat-label>Meses</mat-label>
        <mat-select multiple [ngModel]="monthsSelected" (selectionChange)="onChangeMonth($event)" #monthSelect>
          <mat-checkbox (change)="onSelectAll($event)" class="ps-3" [(ngModel)]="allMonthsSelected">
            Todos
          </mat-checkbox>
          <mat-option *ngFor="let card of monthList; trackBy: trackByIndex" [value]="card.number">{{ card.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Body -->
  <div class="cs-body">

    <!-- Loading -->
    <div class="cs-loading" *ngIf="!requestReady">
      <div class="cs-loading__dots"><span></span><span></span><span></span></div>
      <p class="cs-loading__text">Cargando estadísticas…</p>
    </div>

    <!-- Charts -->
    <ng-container *ngIf="requestReady">
      <div class="row g-4">

        <div class="col-12 col-xl-6">
          <div class="cs-chart-card">
            <div class="cs-chart-card__head">
              <div class="cs-chart-card__badge cs-chart-card__badge--amber">
                <mat-icon>trending_up</mat-icon>
              </div>
              <div>
                <p class="cs-chart-card__title">Conceptos más rentables</p>
                <p class="cs-chart-card__sub">Margen de beneficio por concepto</p>
              </div>
            </div>
            <div class="cs-chart-card__body">
              <div class="cs-empty" *ngIf="chartDataMostCostEffective.labels?.length === 0">
                <mat-icon>show_chart</mat-icon>
                <p>Sin datos para el período seleccionado</p>
              </div>
              <canvas baseChart *ngIf="chartDataMostCostEffective.labels?.length > 0"
                [type]="chartTypeMostCostEffective"
                [data]="chartDataMostCostEffective"
                [options]="chartOptionsMostCostEffective">
              </canvas>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-6">
          <div class="cs-chart-card">
            <div class="cs-chart-card__head">
              <div class="cs-chart-card__badge cs-chart-card__badge--blue">
                <mat-icon>show_chart</mat-icon>
              </div>
              <div>
                <p class="cs-chart-card__title">Conceptos más vendidos</p>
                <p class="cs-chart-card__sub">Número de veces vendido por concepto</p>
              </div>
            </div>
            <div class="cs-chart-card__body">
              <div class="cs-empty" *ngIf="chartDataTopSelling.labels?.length === 0">
                <mat-icon>show_chart</mat-icon>
                <p>Sin datos para el período seleccionado</p>
              </div>
              <canvas baseChart *ngIf="chartDataTopSelling.labels?.length > 0"
                [type]="chartTypeTopSelling"
                [data]="chartDataTopSelling"
                [options]="chartOptionsTopSelling">
              </canvas>
            </div>
          </div>
        </div>

      </div>
    </ng-container>

  </div>

</div>
